<mat-card class="card">
  <mat-card-header class="card-header">
    @if (cardData.hideAvatar === false) {
      <glxy-avatar
        mat-card-avatar
        [width]="36"
        class="user-avatar"
        [src]="cardData.avatar"
        [icon]="cardData.type === 'user' ? 'person' : 'business'"
        />
    }
    <!-- User -->
    @if (cardData.type === 'user' && cardData.userName) {
      <mat-card-title class="name">
        <a [routerLink]="cardData.profileButtonUrl">
          {{ cardData.userName }}
        </a>
      </mat-card-title>
    }

    @if (cardData.type === 'user' && cardData.email) {
      <mat-card-subtitle class="email">
        <div class="card-contents">
          <a href="mailto:{{ cardData.email }}" target="_blank" rel="noopener" (click)="openMailWindow()">
            {{ cardData.email }}
          </a>
          <button mat-icon-button (click)="copyToClipboard(cardData.email)" class="custom-icon-button">
            <mat-icon class="copy-icon" inline>content_copy</mat-icon>
          </button>
        </div>
      </mat-card-subtitle>
    }

    @if (cardData.type === 'user' && cardData.phone) {
      <mat-card-subtitle class="phone">
        <a href="tel:{{ cardData.phone }}">
          {{ cardData.phone }}
        </a>
      </mat-card-subtitle>
    }

    <!-- Business -->
    @if (cardData.type === 'business' && cardData.businessName) {
      <mat-card-title class="name">
        <a [routerLink]="cardData.profileButtonUrl">
          {{ cardData.businessName }}
        </a>
      </mat-card-title>
    }

    @if (cardData.type === 'business' && cardData.businessWebsite) {
      <mat-card-subtitle class="website">
        <a class="link" [href]="cardData.businessWebsite" target="_blank" rel="noopener">
          {{ cardData.businessWebsite }}
        </a>
      </mat-card-subtitle>
    }

    <!-- Account -->
    @if (cardData.type === 'account' && cardData.accountGroupCompanyId) {
      <mat-card-title class="account-id">
        @if (cardData.profileButtonUrl) {
          <a [routerLink]="cardData.profileButtonUrl">
            {{ cardData.accountGroupCompanyId }}
          </a>
        } @else {
          {{ cardData.accountGroupCompanyId }}
        }
      </mat-card-title>
    }

    @if (cardData.type === 'account' && cardData.accountGroupCompanyName) {
      <mat-card-subtitle class="account-name">
        <p>{{ cardData.accountGroupCompanyName ?? '' }}</p>
      </mat-card-subtitle>
    }

    @if (showActionsMenu) {
      <button class="kebab-menu" mat-icon-button matTooltip="Actions" [matMenuTriggerFor]="menu">
        <mat-icon class="menu-icon">more_vert</mat-icon>
      </button>
    }
    <mat-menu [xPosition]="'before'" #menu="matMenu">
      @if (showEditTagButton) {
        <button mat-menu-item (click)="onEditTags()">
          {{ 'ASSOCIATIONS.ACTIONS.EDIT_TAGS' | translate }}
        </button>
      }
      @if (showRemoveButton) {
        <button mat-menu-item (click)="onRemove()">
          {{ 'ASSOCIATIONS.ACTIONS.REMOVE' | translate }}
        </button>
      }
      @for (action of actions; track action) {
        <button mat-menu-item (click)="action.callback(cardData)">
          <span class="action-button">
            {{ action.label | translate }}
            @if (action.icon) {
              <mat-icon>{{ action.icon }}</mat-icon>
            }
          </span>
        </button>
      }
    </mat-menu>
  </mat-card-header>
  <mat-card-content class="content">
    @if (cardData?.type === 'business' && fullBusinessAddress) {
      <crm-common-association-card-content
        [iconName]="'location_on'"
        >
        <div class="full-business-address">{{ fullBusinessAddress }}</div>
      </crm-common-association-card-content>
    }
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
